import { GRID_HEADER_ITEM } from "@constants/colors"
import type { SxProps } from "@mui/material"
import { gridClasses } from "@mui/x-data-grid"

const gridContainer: SxProps = {
  border: 0,
  minHeight: "10rem",
  "& .MuiDataGrid-scrollbar--horizontal": {
    overflow: "visible!important"
  },
  [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]: {
    outline: "none"
  },
  [`& .${gridClasses.row}:focus, & .${gridClasses.row}:focus-within, & .${gridClasses.row}:hover`]:
    {
      backgroundColor: "transparent !important"
    },
  [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]:
    {
      outline: "none"
    }
}

const containerWidth = {
  backgroundColor: "white",
  width: "100%"
}

const headerItems: SxProps = {
  color: GRID_HEADER_ITEM
}
export default {
  containerWidth,
  headerItems,
  gridContainer
}
